// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_login__h4TO9 {
  background-color: var(--color-bg-login);
  width: 100vw;
  height: 100vh;
}

.Login_loginFormContainer__11al\\+ {
  width: 448px;
  min-height: 455px;
  background-color: var(--color-bg-login-box);
  margin-left: auto;
  margin-right: auto;
  margin-top: 200px;
  box-shadow: 0px 3px 6px var(--color-theme-cloud);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 25vh; 
  left: 50vw; 
  transform: translate(-50%, -50%);
}

.Login_loginFormHeader__v2lMa {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 40px;
}

.Login_loginForm__GicdI {
  margin: 40px;
}

.Login_input_container__MCuWh {
  width: 100% !important;
  margin: 10px 0px;
}

.Login_password_input__EOcIf {
  width: 100% !important;
  margin-top: 20px !important;
}

.Login_btnContainer__O7wmb {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.Login_button__kj-Wa {
  width: 174px;
  height: 41px;
  border: 1px solid var(--color-theme-blue) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-blue) !important;
  cursor: pointer;
  font-size: 16px;
  margin-right: 55px;
}

.Login_button__kj-Wa:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.Login_inputError__Qy9uT {
  margin-top: 5px;
  color: var(--color-font-red);
  font-size: 12px;
}

.Login_loginError__N1LYc {
  margin: 12px;
  font-size: 16px;
  color: var(--color-theme-red);
}

.Login_link__CGmPh {
  color: var(--color-font-10);
  padding: 32px;
  font-size: 16px;
}

.Login_forgot_password_container__yv26Q {
  color: var(--color-theme-blue);
  font-size: 16px;
  cursor: pointer;
  margin-left: 12px;
}

.Login_forgot_password_gray__isVIv {
  color: var(--color-theme-lightgray);

  font-size: 16px;
  cursor: pointer;
  margin-left: 12px;
}

.Login_error_message__XQ\\+Ul {
  color: var(--color-theme-red);
}

/* email unverified */
.Login_email_unverified__6nXwS {
  width: 448px;
  height: 179px;
  background-color: var(--color-theme-blue);
  color: var(--color-theme-white);
}

.Login_email_unverified_content__GrdQH {
  padding: 15px;
}

.Login_unverified_info_text__IXClG {
  display: flex;
}

.Login_email_unverified_content__GrdQH p {
  font-weight: bold;
}

.Login_resend_btn_container__q8k4x {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Login_resend_btn__iLDfp {
  color: var(--color-theme-white) !important;
  border: 1px solid var(--color-theme-white) !important;
  width: 336px;
  height: 41px;
  font-weight: bold !important;
  margin: 10px !important;
}

.Login_resend_email_loading__aSFa3 {
  color: var(--color-theme-white) !important;
  margin: 10px;
}

.Login_resend_email_success__O3MtL {
  padding: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.Login_resend_email_success__O3MtL p {
  width: 100px;
  padding-left: 20px;
}

.Login_verification_success_container__FLZlw {
  background-color: var(--color-theme-success-green);
  color: var(--color-theme-white);
  display: flex;
  height: 55px;
  margin-top: 20px;
  align-items: center;
  font-weight: bold;
}

.Login_check_icon__9Abfw {
  padding: 0px 10px 0px 20px;
}

.Login_info_icon__eyq\\+w {
  margin: 3px 10px 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,qDAAqD;EACrD,yCAAyC;EACzC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;;EAEnC,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".login {\n  background-color: var(--color-bg-login);\n  width: 100vw;\n  height: 100vh;\n}\n\n.loginFormContainer {\n  width: 448px;\n  min-height: 455px;\n  background-color: var(--color-bg-login-box);\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 200px;\n  box-shadow: 0px 3px 6px var(--color-theme-cloud);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 25vh; \n  left: 50vw; \n  transform: translate(-50%, -50%);\n}\n\n.loginFormHeader {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 40px;\n}\n\n.loginForm {\n  margin: 40px;\n}\n\n.input_container {\n  width: 100% !important;\n  margin: 10px 0px;\n}\n\n.password_input {\n  width: 100% !important;\n  margin-top: 20px !important;\n}\n\n.btnContainer {\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  width: 174px;\n  height: 41px;\n  border: 1px solid var(--color-theme-blue) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-blue) !important;\n  cursor: pointer;\n  font-size: 16px;\n  margin-right: 55px;\n}\n\n.button:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.inputError {\n  margin-top: 5px;\n  color: var(--color-font-red);\n  font-size: 12px;\n}\n\n.loginError {\n  margin: 12px;\n  font-size: 16px;\n  color: var(--color-theme-red);\n}\n\n.link {\n  color: var(--color-font-10);\n  padding: 32px;\n  font-size: 16px;\n}\n\n.forgot_password_container {\n  color: var(--color-theme-blue);\n  font-size: 16px;\n  cursor: pointer;\n  margin-left: 12px;\n}\n\n.forgot_password_gray {\n  color: var(--color-theme-lightgray);\n\n  font-size: 16px;\n  cursor: pointer;\n  margin-left: 12px;\n}\n\n.error_message {\n  color: var(--color-theme-red);\n}\n\n/* email unverified */\n.email_unverified {\n  width: 448px;\n  height: 179px;\n  background-color: var(--color-theme-blue);\n  color: var(--color-theme-white);\n}\n\n.email_unverified_content {\n  padding: 15px;\n}\n\n.unverified_info_text {\n  display: flex;\n}\n\n.email_unverified_content p {\n  font-weight: bold;\n}\n\n.resend_btn_container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.resend_btn {\n  color: var(--color-theme-white) !important;\n  border: 1px solid var(--color-theme-white) !important;\n  width: 336px;\n  height: 41px;\n  font-weight: bold !important;\n  margin: 10px !important;\n}\n\n.resend_email_loading {\n  color: var(--color-theme-white) !important;\n  margin: 10px;\n}\n\n.resend_email_success {\n  padding: 20px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n\n.resend_email_success p {\n  width: 100px;\n  padding-left: 20px;\n}\n\n.verification_success_container {\n  background-color: var(--color-theme-success-green);\n  color: var(--color-theme-white);\n  display: flex;\n  height: 55px;\n  margin-top: 20px;\n  align-items: center;\n  font-weight: bold;\n}\n\n.check_icon {\n  padding: 0px 10px 0px 20px;\n}\n\n.info_icon {\n  margin: 3px 10px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login": `Login_login__h4TO9`,
	"loginFormContainer": `Login_loginFormContainer__11al+`,
	"loginFormHeader": `Login_loginFormHeader__v2lMa`,
	"loginForm": `Login_loginForm__GicdI`,
	"input_container": `Login_input_container__MCuWh`,
	"password_input": `Login_password_input__EOcIf`,
	"btnContainer": `Login_btnContainer__O7wmb`,
	"button": `Login_button__kj-Wa`,
	"inputError": `Login_inputError__Qy9uT`,
	"loginError": `Login_loginError__N1LYc`,
	"link": `Login_link__CGmPh`,
	"forgot_password_container": `Login_forgot_password_container__yv26Q`,
	"forgot_password_gray": `Login_forgot_password_gray__isVIv`,
	"error_message": `Login_error_message__XQ+Ul`,
	"email_unverified": `Login_email_unverified__6nXwS`,
	"email_unverified_content": `Login_email_unverified_content__GrdQH`,
	"unverified_info_text": `Login_unverified_info_text__IXClG`,
	"resend_btn_container": `Login_resend_btn_container__q8k4x`,
	"resend_btn": `Login_resend_btn__iLDfp`,
	"resend_email_loading": `Login_resend_email_loading__aSFa3`,
	"resend_email_success": `Login_resend_email_success__O3MtL`,
	"verification_success_container": `Login_verification_success_container__FLZlw`,
	"check_icon": `Login_check_icon__9Abfw`,
	"info_icon": `Login_info_icon__eyq+w`
};
export default ___CSS_LOADER_EXPORT___;
